import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#7047EB",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M11.555 6.87a.5.5 0 0 1 .89 0l1.29 2.52a.5.5 0 0 0 .376.267l2.856.402a.5.5 0 0 1 .272.86l-2.042 1.917a.5.5 0 0 0-.15.452l.485 2.725a.5.5 0 0 1-.718.534l-2.588-1.312a.5.5 0 0 0-.452 0l-2.588 1.312a.5.5 0 0 1-.718-.534l.485-2.725a.5.5 0 0 0-.15-.452L6.76 10.919a.5.5 0 0 1 .272-.86l2.856-.402a.5.5 0 0 0 .375-.267z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }